module.exports = __webpack_public_path__ + "static/media/warn.63f80943.png";